import DangerousIcon from '@mui/icons-material/Dangerous';
import PanToolIcon from '@mui/icons-material/PanTool';
import VerifiedIcon from '@mui/icons-material/Verified';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ComplianceChecklistItemStatus } from '../../../../../../../../../../../../../generated/core-api/graphql-react-query';
import StyledTypography from './styles';

interface ComplianceTagProps {
  status: ComplianceChecklistItemStatus;
}

export default function ComplianceTag(props: ComplianceTagProps) {
  const { status } = props;
  const { t } = useTranslation();
  return (
    <StyledTypography
      className={clsx({
        error: status !== ComplianceChecklistItemStatus.Validated,
        smallIcon: status === ComplianceChecklistItemStatus.NotValidated,
      })}
    >
      {status === ComplianceChecklistItemStatus.Validated && <VerifiedIcon />}
      {status === ComplianceChecklistItemStatus.NotValidated && <PanToolIcon />}
      {status === ComplianceChecklistItemStatus.Rejected && <DangerousIcon />}
      {t(`home-page.compliance.mandatory.state.${status}`)}
    </StyledTypography>
  );
}
